<!-- eslint-disable max-lines -->
<!-- 逾期概览 -->
<template>
    <div class="page personal-overdue">
        <div class="page-content">
            <!-- 条件筛选 -->

            <box :showheader="false" class="box-custom search-box">
                <div class="page-content-top">
                    <searchList :searchListConfig="searchListConfig" :roleCodes="roleCodes" :currentRole="currentRole"
                        :currentUserName="currentUserName" @resetCurrent="resetCurrent"
                        :searchOptionsList="searchOptionsList" @search-handle="searchHandle"
                        :searchInitData="searchInitData" />
                    <update-time @reset-current="resetCurrent" :updateTimeBigdataList="updateTimeBigdataList" />
                </div>
            </box>

            <div class="page-head-box">
                <!-- 逾期概览图表 -->
                <chartsData2 class="charts-conent" :key="chartKey" :show-more-link="false" :currentRole="currentRole"
                    :config="_chartsConfig.overdueConfig" :performanceData="overdueYearDetail"
                    :chartsData="overdueYearData" />
            </div>
            <!-- 外部各行业逾期情况 -->
            <box title="逾期应收客户" class="box-custom" v-loading="outSideLoading">
                <table-item ref="outSideTableRef" :beforeRequest="outSideRequestConfig.beforeRequest"
                    :afterRequest="outSideRequestConfig.afterRequest" :height="outsideColumnsConfig.height"
                    :columns="outsideColumnsConfig.columns" :params="outSideParams">
                </table-item>
            </box>

        </div>
    </div>
</template>
<script>
import { ref, reactive, onMounted, computed, getCurrentInstance, onActivated, watch } from '@vue/composition-api';
import searchList from '@/views/index/searchList/Index.vue';
import { getUserRoleList, queryUserDataAuth, getOverduePandectMonth, getOverduePandectYear } from '@/api/homePageApi';
import store from '@/store';
import updateTime from '@/views/components/UpdateTime.vue';
import box from '@/views/components/Box.vue';
import { outsideColumnsConfig, searchListConfig, updateTimeBigdataList } from './column.config.js';
import { chartsConfig, formatValue, whileList } from '../../../index/config.js';
import chartsData2 from '@/views/index/chartsData/Index2.vue';
import _ from 'lodash';
import homeBgPic from '@/assets/images/homeBg.png';
import tableItem from '@/views/subPage/component/TableItem.vue';
import { getPersonalOverdueCustomerDetail } from '@/api/subPageApi.js';
// import ChartView from '@/lib/echarts/ChartView.vue';
import { getSession } from '@/components/utils/storage';
export default {
    components: {
        searchList,
        updateTime,
        box,
        chartsData2,
        tableItem
        // ChartView
    },
    // eslint-disable-next-line max-lines-per-function
    setup() {
        const { userCode } = store.getters.user;
        // const homeLoading = ref(false);
        const outSideTableRef = ref(null);
        const currentRole = ref({});
        const currentUserName = ref('');
        const roleCodes = ref([]);
        const searchOptionsList = ref({});
        // 顶部筛选条件
        const searchData = ref({});
        // 表单筛选条件
        // 外部各行业收入情况
        const org = reactive({
            radioValue: '片区',
            radioGroup: [{
                value: '片区',
                label: '片区'
            }, {
                value: '分公司',
                label: '分公司'
            }, {
                value: '经营中心',
                label: '经营中心'
            }, {
                value: '专司',
                label: '专司'
            }]
        });

        const getPersonalParams = () => {
            let param = {};
            if (currentRole.value.dataType === 'personal') {
                param = _.cloneDeep(currentRole.value);
            }
            param.roleType = param.dataType;
            delete param.dataType;
            return param;
        };
        // 公用参数
        const getParams = computed(() => {
            return {
                refresh: true,
                transactionClassCode: `2`, // 默认外部
                serviceProductCode: `'all'`,
                organizationCode: `'all'`,
                industryTypeCode: `'all'`,
                userCode: userCode, // 测试账号
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime,
                costType: isYear.value ? '2' : '1',
                customerlevelName: searchData.value.customerlevelName,
                ebcdCode: searchData.value.ebcdCode,
                typeId: searchData.value.typeId,
                areaCode: searchData.value.areaCode,
                subBranchCode: searchData.value.subBranchCode,
                type: isYear.value ? 'dashboard_income_angles_year_lcrm' : 'dashboard_income_angles_month_lcrm',
                businessSceneBigCategory: searchData.value.businessSceneBigCategory,
                bigEbcdName: searchData.value.bigEbcdName
            };
        });

        // 外部各行业表格入参
        const outSideParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'businessSceneBigCategory',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'organizationCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                api: getPersonalOverdueCustomerDetail
            };
        });

        // 外部各行业请求配置
        const outSideRequestConfig = {
            beforeRequest: (condition) => {
                return outSideParams.value;
            }
            // afterRequest: (res) => {
            //     if (res && +res.code === 0) {
            //         return {
            //             data: res.data
            //         };
            //     }
            // }
        };

        const isYear = computed(() => {
            return searchData.value?.timeStatus === 'year';
        });
        // 个人维度需要隐藏字段
        const hiddenPropHandle = (val) => {
            const data = _.cloneDeep(val);
            data.titleTips = '';
            data.titleTipsPersonal = '';
            if (currentRole.value.dataType === 'personal') {
                data.headConfig = data.headConfig.filter(it => !it.isHiddenPersonal);
            }
            return data;
        };
        // 根据年/月维度动态切换表格字段
        const _chartsConfig = computed(() => {
            return {
                overdueConfig: searchData.value.timeStatus === 'year' ? hiddenPropHandle(chartsConfig.overdueYear) : hiddenPropHandle(chartsConfig.overdueMonth)
            };
        });

        const setStrFormat = (val) => {
            if (!Array.isArray(val)) return val;
            return val?.map(item => `'${item}'`).join(',') || '';
        };

        const setCommaStrFormat = (val) => {
            let str = '';
            for (let i = 0; i < val.length; i++) {
                if (val[i].indexOf(',') >= 0) {
                    const arr = val[i].split(',');
                    for (let j = 0; j < arr.length; j++) {
                        str += "'" + arr[j] + "',";
                    }
                } else {
                    str += "'" + val[i] + "',";
                }
            }
            return str.substring(0, str.length - 1); // 删除最后的逗号
        };
        // 筛选赋值
        const searchHandle = (val) => {
            searchData.value = _.cloneDeep(val);
            if (val.industryCategory?.length) {
                searchData.value.typeId = val.industryCategory.map(it => it[0]);
            } else {
                searchData.value.typeId = [];
            }

            searchData.value.ebcdCode = setCommaStrFormat(searchData.value.ebcdCode) || "'all'"; // 专业公司编码
            searchData.value.typeId = setStrFormat(searchData.value.typeId) || "'all'"; // 行业大类
            searchData.value.areaCode = setStrFormat(searchData.value.areaCode) || "'all'"; // 片区
            searchData.value.subBranchCode = setStrFormat(searchData.value.subBranchCode) || "'all'"; // 分公司
            searchData.value.businessSceneBigCategory = setStrFormat(searchData.value.businessSceneBigCategory) || "'all'"; // 业务场景
            getAllData();
        };

        // 获取页面所有数据
        const getAllData = () => {
            if (isYear.value) {
                getOverduePandectYearInfo();
            } else {
                getOverduePandectMonthInfo();
            }
        };
        const resetCurrent = () => {
            getAllData();
        };
        const currentUserMip = ref('');
        // 获取用户角色list
        // eslint-disable-next-line max-lines-per-function
        const getUserRoleInfo = () => {
            if (currentRole.value.dataType && store.getters.homePageParams?.dataType !== 'personal') return;
            const currentRoleHome = getSession('currentRoleHome');
            if (store.getters.homePageParams?.dataType || currentRoleHome?.dataType) {
                const _currentRole = _.pick(store.getters.homePageParams, [
                    'roleCode',
                    'roleName',
                    'dataType',
                    'sortNo'
                ]);
                currentRole.value = _currentRole.dataType ? _currentRole : currentRoleHome;
                return;
            }
            const params = { userCode: userCode };
            if (currentRole.value) {
                params.userRoleDataType = currentRole.value.dataType;
            }
            // homeLoading.value = true;

            return getUserRoleList(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    roleCodes.value = res.data.roleCodes;
                    if (Array.isArray(roleCodes.value) && roleCodes.value?.length) {
                        currentRole.value = roleCodes.value[0];
                    }
                    // customerStatusList.value = statusList.customerList.filter(it => it.role.includes(String(currentRole.value.dataType)));
                    // customerActive.value = customerStatusList.value[0].type;
                } else {
                    // resetLoading.value = false;
                    // homeLoading.value = false;
                }
            }).catch(() => {
                // resetLoading.value = false;
                // homeLoading.value = false;
            }).finally(() => {
                // homePageShow.value = true;
            });
        };
        const ctx = getCurrentInstance();
        const searchInitData = ref({});
        const getUserDataInfo = () => {
            searchInitData.value = {};
            const params = {
                ...currentRole.value,
                roleType: currentRole.value.dataType
            };
            return queryUserDataAuth(params).then(res => {
                if (res && +res.code === 0) {
                    searchOptionsList.value = res.data;
                    searchInitData.value = store.getters.homePageParams;
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                }
            });
        };

        // 逾期应收概-年
        const overdueYearDetail = ref({});
        const overdueYearData = ref([]);
        // eslint-disable-next-line max-lines-per-function
        const getOverduePandectYearInfo = (data = {}) => {
            //  TOP 和2024年才有数据
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'transactionClassCode',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataTime',
                    'customerlevelName',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'bigEbcdName'
                ]),
                requestType: '2',
                systemType: '业务口径',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                type: 'dashboard_overdue_pandect_year_lcrm',
                dataType: searchData.value.timeStatus === 'year' ? 'Y' : 'M',
                ...getPersonalParams()
            };
            delete params.serviceProductCode;
            return getOverduePandectYear(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.data.length === 0) {
                        overdueYearDetail.value = {};
                        overdueYearData.value = [];
                        return;
                    }
                    overdueYearData.value = [{
                        name: '应收账款',
                        value: res.data[0].arAmt
                    }, {
                        name: '逾期账款',
                        value: res.data[0].amtOverdue
                    }, {
                        name: '本月到期',
                        value: res.data[0].amtDue
                    }];
                    const _data = _.cloneDeep(res.data[0]);
                    // eslint-disable-next-line guard-for-in
                    for (const item in _data) {
                        _data[item] = formatValue(_data[item]);
                    }
                    overdueYearDetail.value = _data;
                }
            });
        };
        // 逾期应收概-月
        // const overdueMonthDetail = ref([]);
        // eslint-disable-next-line max-lines-per-function
        const getOverduePandectMonthInfo = (data = {}) => {
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'transactionClassCode',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataTime',
                    'customerlevelName',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'bigEbcdName'
                ]),
                requestType: '2',
                systemType: '业务口径',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                type: 'dashboard_overdue_pandect_month_lcrm',
                dataType: searchData.value.timeStatus === 'year' ? 'Y' : 'M',
                ...getPersonalParams()
            };
            delete params.serviceProductCode;
            return getOverduePandectMonth(params).then(res => {
                if (res && +res.code === 0) {
                    if (res && +res.code === 0) {
                        if (res.data.length === 0) {
                            overdueYearDetail.value = {};
                            overdueYearData.value = [];
                            return;
                        }
                        overdueYearData.value = [{
                            name: '应收账款',
                            value: res.data[0].arAmt
                        }, {
                            name: '逾期账款',
                            value: res.data[0].amtOverdue
                        }, {
                            name: '本月到期',
                            value: res.data[0].amtDue
                        }];
                        const _data = _.cloneDeep(res.data[0]);
                        // eslint-disable-next-line guard-for-in
                        for (const item in _data) {
                            _data[item] = formatValue(_data[item]);
                        }
                        overdueYearDetail.value = _data;
                    }
                }
            });
        };
        onMounted(async () => {
            document.querySelector('.el-main').style['background']
                = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
        });
        const chartKey = ref(1);
        onActivated(async () => {
            ++chartKey.value;
            await getUserRoleInfo();
            await getUserDataInfo();
        });
        watch(
            () => ctx.$route,
            (newVal) => {
                if (!whileList.includes(newVal.name) && document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background'] = '#f3f4f6';
                } else if (document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background']
                        = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );

        // 表格loading状态统一管理
        const getTableLoading = (tableRef) => computed(() => tableRef.value?.tableListInstance?.tableLoading);
        // 逾期应收客户loading
        const outSideLoading = getTableLoading(outSideTableRef);

        return {
            currentRole,
            currentUserName,
            roleCodes,
            searchOptionsList,
            searchHandle,
            resetCurrent,
            outsideColumnsConfig,
            chartsConfig,
            org,
            overdueYearDetail,
            searchData,
            getOverduePandectYearInfo,
            getOverduePandectMonthInfo,
            overdueYearData,

            _chartsConfig,
            isYear,
            searchInitData,
            outSideRequestConfig,

            outSideParams,
            searchListConfig,
            chartKey,
            updateTimeBigdataList,
            outSideLoading,
            outSideTableRef
        };
    }
};
</script>
<style scoped lang="less">
.page {
    min-width: 1500px;
    width: 100%;

    &-content {
        width: 100%;
        padding: 0 0 10px 0;

        .page-head-box {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
        }

        // 图表
        .charts-conent {
            width: calc(100%);
            padding: 16px;
            box-sizing: border-box;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            backdrop-filter: blur(25px);
            background: #ffffff;
            //  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            // 最后一个元素不要margin-bottom
            margin-bottom: 10px;

        }

        .mr10 {
            margin-right: 10px;
        }

        .search-box {
            position: sticky;
            top: 0;
            z-index: 100;
            backdrop-filter: blur(25px);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
            box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        }

        // 按钮组
        .search-radio {
            margin-bottom: 10px;

            // 深度选择
            /deep/ .el-radio-button__inner {
                padding: 5px 15px;
            }

            /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                color: #2881FF;
                border-color: #2881FF;
                background-color: #E5F0FE;
            }

            /deep/ .el-radio-button:first-child:last-child .el-radio-button__inner {
                border-radius: 0px 2px 2px 0px !important;
            }
        }

        .box-custom {
            margin-bottom: 10px;
        }

        .page-content-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>
